import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddPartyDiscount from "./addPartyDiscount";
import GetAllPartyDiscount from "./getAllPartyDiscount";


const PartyDiscount = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  return (
    <div>
      

      <AddPartyDiscount />

      <GetAllPartyDiscount />
    </div>
  );
};

export default PartyDiscount;
